import { defineElement, FC, onDidLoad, useElements, useListen } from '@atomify/hooks';

const TAB_ATTRIBUTE = 'tab';

const Downloads: FC = () => {
    const downloadsTabs = useElements<HTMLElement[]>('[js-hook-downloads-tab]');
    const documents = useElements<HTMLElement[]>('[js-hook-downloads-documents]');

    onDidLoad(() => {
        if (!downloadsTabs.current[0] || !documents.current[0]) return;
        downloadsTabs.current[0]?.setAttribute('selected', '');

        [...documents.current].forEach((document: HTMLElement) => {
            const tabIndex = document.getAttribute(TAB_ATTRIBUTE);

            if (tabIndex && tabIndex != '1') {
                document.style.display = 'none';
            }
        });

        documents.current[0].style.display = 'block';
    });

    function hideNonIndexDocuments(tabIndex: string) {
        [...documents.current].forEach((element: HTMLElement) => {
            if (element.getAttribute(TAB_ATTRIBUTE) != tabIndex) {
                element.style.display = 'none';
            }
        });
    }

    function toggleSelectedTab(tabIndex: string) {
        [...downloadsTabs.current].forEach((tab: HTMLElement) => {
            if (tab.getAttribute(TAB_ATTRIBUTE) != tabIndex) {
                tab.removeAttribute('selected');
            }
        });
    }

    useListen(downloadsTabs, 'click', (e: any) => {
        e.preventDefault();
        const { currentTarget } = e;

        const tabIndex = currentTarget.getAttribute(TAB_ATTRIBUTE);

        [...documents.current].forEach((element: HTMLElement) => {
            if (element.getAttribute('tab') === tabIndex) {
                element.style.display = 'block';

                currentTarget.setAttribute('selected', '');
                hideNonIndexDocuments(tabIndex);
                toggleSelectedTab(tabIndex);
            }
        });
    });
};

defineElement('bpd-downloads', Downloads);
